var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MDCDrawer } from '@material/drawer';
import { hasItems } from '@bestadapted/utility';
import classNames from 'classnames';
import React, { Component, useRef } from 'react';
import { style } from 'typestyle';
import { Drawer } from '../drawer/Drawer';
import { TopAppBar } from '../top-app-bar/TopAppBar';
import './drawer-frame.css';
import { useScroll } from 'react-use';
var DrawerFrame = /** @class */ (function (_super) {
    __extends(DrawerFrame, _super);
    function DrawerFrame(props) {
        var _a, _b, _c;
        var _this = _super.call(this, props) || this;
        _this.initDrawer = function (drawerEle) {
            if (!drawerEle)
                return;
            if (_this.props.type === 'dismissible' || _this.props.type === 'modal') {
                _this.drawer = MDCDrawer.attachTo(drawerEle);
            }
        };
        _this.closeDrawer = function () {
            if (_this.props.type === 'modal' && _this.drawer) {
                _this.drawer.open = false;
            }
        };
        _this.initTopAppBar = function (topAppBar) {
            if (_this.drawer && topAppBar) {
                topAppBar.addEventListener('MDCTopAppBar:nav', function () { return (_this.drawer.open = !_this.drawer.open); });
            }
        };
        _this.state = {
            selectedItem: (_c = (_b = (_a = _this.props.groups) === null || _a === void 0 ? void 0 : _a.find) === null || _b === void 0 ? void 0 : _b.call(_a, function (x) { return x === null || x === void 0 ? void 0 : x.selected; })) !== null && _c !== void 0 ? _c : undefined
        };
        return _this;
    }
    DrawerFrame.prototype.componentWillUnmount = function () {
        if (this.drawer)
            this.drawer.destroy();
    };
    DrawerFrame.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, type = _c.type, adapter = _c.adapter, actionItems = _c.actionItems, groups = _c.groups, header = _c.header, className = _c.className, content = _c.content;
        var showMenu = type === 'permanent' ? false : hasItems(groups);
        var classes = classNames({
            'drawer-top-app-bar': content === 'full-height' || content === 'below-app-bar'
        }, className);
        var CreateFullHeight = function () {
            var _a, _b;
            var scrollRef = useRef(null);
            var y = useScroll(scrollRef).y;
            return (React.createElement("div", { className: "drawer-frame-root " + style({
                    height: '100vh'
                }) },
                React.createElement(Drawer, { groups: groups, type: type, header: header, init: _this.initDrawer, closeDrawer: _this.closeDrawer, className: className, onNavClick: function (item) {
                        return _this.setState(__assign(__assign({}, _this.state), { selectedItem: item }));
                    } }),
                React.createElement("div", { className: "mdc-drawer-app-content" },
                    adapter && (React.createElement(TopAppBar, { showMenu: showMenu, adapter: adapter, renderLogo: _this.props.renderLogo, actionItems: actionItems, title: (_b = (_a = _this.state.selectedItem) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLowerCase(), init: _this.initTopAppBar, className: classes + " " + (y > 0
                            ? 'mdc-top-app-bar--fixed-scrolled'
                            : ''), style: _this.props.style })),
                    React.createElement("main", { className: "main-content page-bg", id: "main-content", ref: scrollRef },
                        React.createElement("div", { className: "mdc-top-app-bar--fixed-adjust" }, _this.props.children)))));
        };
        var CreateBelowAppBar = function () {
            var _a, _b;
            return (React.createElement("div", { className: "drawer-frame-root " + style({
                    height: '100vh'
                }) },
                React.createElement(TopAppBar, { showMenu: showMenu, adapter: adapter, renderLogo: _this.props.renderLogo, actionItems: actionItems, init: _this.initTopAppBar, title: (_b = (_a = _this.state.selectedItem) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLowerCase(), className: (className !== null && className !== void 0 ? className : '') + ' drawer-top-app-bar' }),
                React.createElement(Drawer, { groups: groups, type: type, init: _this.initDrawer, className: "mdc-top-app-bar--fixed-adjust", closeDrawer: _this.closeDrawer, onNavClick: function (item) {
                        return _this.setState(__assign(__assign({}, _this.state), { selectedItem: item }));
                    } }),
                React.createElement("div", { className: "mdc-drawer-app-content mdc-top-app-bar--fixed-adjust" },
                    React.createElement("main", { className: "main-content page-bg", id: "main-content" }, _this.props.children))));
        };
        if (!content)
            return (React.createElement("div", { className: "drawer-frame-root", style: { minHeight: '100vh' } },
                React.createElement(Drawer, { groups: groups, type: type, header: header, init: this.initDrawer, closeDrawer: this.closeDrawer, onNavClick: function (item) {
                        return _this.setState(__assign(__assign({}, _this.state), { selectedItem: item }));
                    } }),
                getScrim(type),
                React.createElement("div", { className: "drawer-frame-app-content" },
                    React.createElement(TopAppBar, { showMenu: showMenu, adapter: adapter, renderLogo: this.props.renderLogo, actionItems: actionItems, title: (_b = (_a = this.state.selectedItem) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLowerCase(), init: this.initTopAppBar, className: classes })),
                React.createElement("div", { className: "mdc-top-app-bar--fixed-adjust page-bg " + style({ width: '100%' }) }, this.props.children)));
        return content === 'full-height' ? (React.createElement(CreateFullHeight, null)) : (React.createElement(CreateBelowAppBar, null));
    };
    DrawerFrame.displayName = 'ba-drawer-frame';
    return DrawerFrame;
}(Component));
export { DrawerFrame };
var getScrim = function (type) {
    if (type === 'modal') {
        return React.createElement("div", { className: "mdc-drawer-scrim" });
    }
    return null;
};
//# sourceMappingURL=DrawerFrame.js.map